import React, { useEffect } from "react";
import { ChannelIdProd, PegaServerProd } from "../../redux/Server";

const PegaGadgetHTML = ({ currentToken }) => {
  useEffect(() => {
    window.pega.web.api.removeGadget("PegaGadget");
    window.pega.web.api.updateGadgets();
    window._initAllPegaObjects();
    window.pega.web.api.doAction("PegaGadget", "load");
  }, []);

  return (
    <div
      className="iframe-container"
      data-pega-gadgetname="PegaGadget"
      data-pega-action="display"
      data-pega-action-param-harnessname="HeyadUserPortal"
      data-pega-action-param-classname="ZTC-Heyad-UIPages"
      data-pega-action-param-model=""
      data-pega-action-param-readonly="false"
      data-pega-isdeferloaded="false"
      data-pega-applicationname="Heyad"
      data-pega-threadname="Heyad"
      data-pega-channelID={ChannelIdProd}
      data-pega-resizetype="stretch"
      data-pega-url={`${PegaServerProd}/prweb/MUAuth/app/heyad/`}
      data-pega-action-param-parameters={JSON.stringify({
        pzSkinName: "HeyadGreen",
        pyMashupSkeletonName: "pyDefaultMashupSkeleton",
        Tocken: currentToken,
      })}
    />
  );
};

export default PegaGadgetHTML;
